// ============================================
// FILE: apiSetup/decodeToken.ts
// ============================================
export interface DecodedAccessToken {
  user: {
    id: string;
    role: string;
    teacher_id?: string;
    student_id?: string;
  };
  exp: number;
  iat: number;
}

export const decodeAccessToken = (token: string): DecodedAccessToken | null => {
  try {
    const payload = token.split('.')[1];
    return JSON.parse(atob(payload));
  } catch (e) {
    console.error('❌ Failed to decode access token:', e);
    return null;
  }
};